// import { useContext, useState, useEffect, useRef } from "react";
// import axios from "axios";
// import { AuthContext } from "../context/AuthContext";
// import { API_URL } from "../../Constants";
// import Select from "react-select";
// import { toast } from "react-toastify";

// export default function IssueForm({
//   showIssueForm,
//   onIssueCreated,
//   setOpenForm = null,
//   editData = null,
//   onIssueUpdated,
// }) {
//   const { user } = useContext(AuthContext);
//   const [users, setUsers] = useState([]);
//   const [statuses, setStatuses] = useState([]);
//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const [emailError, setEmailError] = useState("");
//   const [formData, setFormData] = useState({
//     companyId: user.accountType === "COMPANY" ? user.id : user.companyId,
//     title: "",
//     description: "",
//     statusName: "",
//     statusColor: "",
//     priority: "Low",
//     severity: "",
//     type: "",
//     environment: "",
//     tags: [],
//     expectedFixDate: "",
//     reportedById: user?.id,
//     reportedByName: user?.name,
//     assignedToJson: JSON.stringify([]),
//     participants: [],
//     reproducibleSteps: "",
//     taskId: "",
//     projectId: "",
//     files: [],
//   });
//   const [participantEmail, setParticipantEmail] = useState("");
//   const [showNotifyModal, setShowNotifyModal] = useState(false);
//   const [pendingParticipant, setPendingParticipant] = useState(null);
//   const fileInputRef = useRef(null);
//   const [severities, setSeverities] = useState([]);
//   const [environments, setEnvironments] = useState([]);
//   const [type, setType] = useState([]);

//   // Allowed mime types & max size (bytes)
//   // Update this constant near the top of the component
// const ALLOWED_TYPES = [
//   "image/png",
//   "image/jpeg",
//   "application/pdf",
//   "application/msword", // .doc
//   "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // .docx
//   "text/plain", // .txt
//   "text/csv", // .csv
//   "application/vnd.ms-excel", // .xls
//   "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // .xlsx
// ];
//   const MAX_SIZE = 10 * 1024 * 1024; // 10 MB

//   // Clipboard-paste listener (mount once)
//   useEffect(() => {
//     function handlePaste(e) {
//       const files = [];
//       const items = [...e.clipboardData.items];
      
//       for (const item of items) {
//         if (item.kind === 'file') {
//           const file = item.getAsFile();
//           if (file && ALLOWED_TYPES.includes(file.type)) {
//             if (file.size > MAX_SIZE) {
//               toast.error(`${file.name} exceeds 10 MB limit`);
//               continue;
//             }
//             files.push(file);
//           }
//   }
//       }

//       if (files.length > 0) {
//         setFormData(prev => ({
//           ...prev,
//           files: [...prev.files, ...files]
//         }));
//         toast.success(`Added ${files.length} file(s) from clipboard`);
//       }
//     }

//     window.addEventListener("paste", handlePaste);
//     return () => window.removeEventListener("paste", handlePaste);
//   }, []);

//   useEffect(() => {
//     async function fetchInitialData() {
//       const companyId =
//         user?.accountType === "COMPANY" ? user.id : user?.companyId;

//       try {
//         // Fetch statuses
//         const statusResponse = await axios.get(
//           `${API_URL}/api/issueStatus/company/${companyId}`,
//           {
//             headers: {
//               authorization: `Bearer ${localStorage.getItem("token")}`,
//             },
//           }
//         );

//         // Fetch types
//         const typeResponse = await axios.get(
//           `${API_URL}/api/issueType/company/${companyId}`,
//           {
//             headers: {
//               authorization: `Bearer ${localStorage.getItem("token")}`,
//             },
//           }
//         );

//         // Fetch severities
//         const severityResponse = await axios.get(
//           `${API_URL}/api/severityTemplate/company/${companyId}`,
//           {
//             headers: {
//               authorization: `Bearer ${localStorage.getItem("token")}`,
//             },
//           }
//         );

//         // Fetch environments
//         const environmentResponse = await axios.get(
//           `${API_URL}/api/environment/company/${companyId}`,
//           {
//             headers: {
//               authorization: `Bearer ${localStorage.getItem("token")}`,
//             },
//           }
//         );

//         setStatuses(statusResponse.data);
//         setType(typeResponse.data);
//         setSeverities(severityResponse.data);
//         setEnvironments(environmentResponse.data);
//       } catch (error) {
//         console.error("Error fetching initial data:", error);
//       }
//     }
//     fetchInitialData();
//   }, [user]);

//   // Fetch Users
//   useEffect(() => {
//     async function fetchUsers() {
//       if (!user?.id || !user?.accountType) return;
//       const url =
//         user?.accountType === "COMPANY"
//           ? `${API_URL}/api/companyuser/getByUserId?userId=${user.id}&accountType=${user.accountType}`
//           : `${API_URL}/api/companyuser/getSameAndSubordinateUsers?userId=${user.id}&accountType=${user.accountType}`;

//       try {
//         const response = await fetch(url, {
//           method: "GET",
//           headers: {
//             authorization: `Bearer ${localStorage.getItem("token")}`,
//             "Content-Type": "application/json",
//           },
//         });

//         if (!response.ok) {
//           throw new Error(`HTTP error! Status: ${response.status}`);
//         }

//         const data = await response.json();
//         setUsers(data);
//       } catch (error) {
//         console.error("Error fetching users:", error);
//       }
//     }
//     fetchUsers();
//   }, [user]);

//   useEffect(() => {
//   if (editData) {
//     setFormData({
//       companyId: editData.companyId,
//       title: editData.title || "",
//       description: editData.description || "",
//       statusName: editData.statusName || "",
//       statusColor: editData.statusColor || "",
//       priority: editData.priority || "Low",
//       severity: editData.severity || "",
//       type: editData.type || "",
//       environment: editData.environment || "",
//       tags: editData.tags || [],
//       expectedFixDate: editData.expectedFixDate || "",
//       reportedById: editData.reportedById || user?.id,
//       reportedByName: editData.reportedByName || user?.name,
//       assignedToJson: editData.assignedTo 
//         ? JSON.stringify(editData.assignedTo)
//         : JSON.stringify([]),
//       participants: editData.participants || [],
//       reproducibleSteps: editData.reproducibleSteps || "",
//       taskId: editData.taskId || "",
//       projectId: editData.projectId || "",
//       attachments: editData.attachments || [], // This ensures it's always an array
//       files: [], // Initialize files as empty array for new uploads
//     });
    
//     const participantEmails = editData.participants?.map(p => 
//       Array.isArray(p) ? p[1] || p[0] : p
//     ) || [];
//     setParticipantEmail(participantEmails.join(', '));
//   }
// }, [editData, user?.id, user?.name]);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData({ ...formData, [name]: value });
//   };

//   const handleAssignedUsersChange = (selectedOptions) => {
//     const assignedUsers = selectedOptions.map((option) => ({
//       id: option.value,
//       name: option.label,
//     }));

//     setFormData({
//       ...formData,
//       assignedToJson: JSON.stringify(assignedUsers),
//     });
//   };

//   const handleTagsChange = (e) => {
//     const value = e.target.value;
//     if (e.key === "Enter" || e.key === ",") {
//       e.preventDefault();
//       if (value.trim()) {
//         setFormData((prev) => ({
//           ...prev,
//           tags: [...prev.tags, value.trim()],
//         }));
//         e.target.value = "";
//       }
//     }
//   };

//   const removeTag = (indexToRemove) => {
//     setFormData((prev) => ({
//       ...prev,
//       tags: prev.tags.filter((_, index) => index !== indexToRemove),
//     }));
//   };

//   const handleFileChange = (e) => {
//     const files = Array.from(e.target.files);
//     const validFiles = [];
    
//     for (const file of files) {
//       if (!ALLOWED_TYPES.includes(file.type)) {
//         toast.error(`Unsupported file type: ${file.name}`);
//         continue;
//       }
//       if (file.size > MAX_SIZE) {
//         toast.error(`${file.name} exceeds 10 MB limit`);
//         continue;
//       }
//       validFiles.push(file);
//     }

//     if (validFiles.length > 0) {
//       setFormData(prev => ({
//         ...prev,
//         files: [...prev.files, ...validFiles]
//       }));
//     }
//   };

//   const removeFile = (indexToRemove) => {
//     setFormData(prev => ({
//       ...prev,
//       files: prev.files.filter((_, index) => index !== indexToRemove)
//     }));
//   };

//   const removeAttachment = (indexToRemove) => {
//   setFormData(prev => ({
//     ...prev,
//     attachments: prev.attachments.filter((_, index) => index !== indexToRemove)
//   }));
// };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setIsSubmitting(true);

//     try {
//       const formDataToSend = new FormData();
      
//       // Append all form data to FormData object
//       Object.keys(formData).forEach((key) => {
//         if (formData[key] !== null && formData[key] !== undefined) {
//           if (key === "files" && formData.files.length > 0) {
//             formData.files.forEach(file => {
//               formDataToSend.append("files", file);
//             });
//           } else if (key === "tags" && formData.tags.length > 0) {
//             formData.tags.forEach(tag => {
//               formDataToSend.append("tags", tag);
//             });
//           } else if (key === "participants" && formData.participants.length > 0) {
//             formData.participants.forEach(participant => {
//               formDataToSend.append("participants", participant);
//             });
//           } else {
//             formDataToSend.append(key, formData[key]);
//           }
//         }
//       });

//       let response;
//       if (editData) {
//         response = await axios.put(
//           `${API_URL}/api/issues/${editData.issueId}/updatedBy/${user.name}`,
//           formDataToSend,
//           {
//             headers: {
//               authorization: `Bearer ${localStorage.getItem("token")}`,
//               "Content-Type": "multipart/form-data",
//             },
//           }
//         );
//       } else {
//         response = await axios.post(
//           `${API_URL}/api/issues`,
//           formDataToSend,
//           {
//             headers: {
//               authorization: `Bearer ${localStorage.getItem("token")}`,
//               "Content-Type": "multipart/form-data",
//             },
//           }
//         );
//       }

//       if (response.data?.status === "Successful") {
//   toast.success(response.data.message);
  
//   // Reset form
//   setFormData({
//     companyId: user.accountType === "COMPANY" ? user.id : user.companyId,
//     title: "",
//     description: "",
//     statusName: "",
//     statusColor: "",
//     priority: "Low",
//     severity: "",
//     type: "",
//     environment: "",
//     tags: [],
//     expectedFixDate: "",
//     reportedById: user?.id,
//     reportedByName: user?.name,
//     assignedToJson: JSON.stringify([]),
//     participants: [],
//     reproducibleSteps: "",
//     taskId: "",
//     projectId: "",
//     files: [],
//     attachments: [],
//   });

//   // Close the form
//   if (typeof showIssueForm === 'function') {
//     showIssueForm(false);
//   }
//   if (typeof setOpenForm === 'function') {
//     setOpenForm(null);
//   }

//   // Trigger update callbacks
//   if (editData) {
//     if (typeof onIssueUpdated === 'function') {
//       onIssueUpdated(response.data);
//     }
//   } else {
//     window.dispatchEvent(new Event("issueCreated"));
//     if (typeof onIssueCreated === 'function') {
//       onIssueCreated(response.data);
//     }}
        
//         showIssueForm?.(false);
//         setOpenForm?.(null);
//       } else {
//         toast.error(response.data?.message);
//       }
//     } catch (error) {
//       console.error("Issue operation error:", error);
//       toast.error(error.response?.data?.message || error.message);
//     } finally {
//       setIsSubmitting(false);
//     }
//   };

//   const handleAddParticipant = () => {
//     setEmailError("");

//     if (!participantEmail) {
//       setEmailError("Please enter an email address");
//       return;
//     }

//     const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//     if (!emailRegex.test(participantEmail)) {
//       setEmailError("Please enter a valid email address");
//       return;
//     }

//     const isDuplicate = formData.participants.some((participant) => {
//       const email = Array.isArray(participant)
//         ? participant[1] || participant[0]
//         : participant;
//       return email.toLowerCase() === participantEmail.toLowerCase();
//     });

//     if (isDuplicate) {
//       setEmailError("This email is already added");
//       return;
//     }

//     const matchedUser = users.find(
//       (u) => u.email.toLowerCase() === participantEmail.toLowerCase()
//     );
//     if (matchedUser) {
//       setPendingParticipant({ id: matchedUser.id, email: participantEmail });
//       setShowNotifyModal(true);
//     } else {
//       setFormData((prev) => ({
//         ...prev,
//         participants: [...prev.participants, [participantEmail]],
//       }));
//       setParticipantEmail("");
//     }
//   };

//   const confirmParticipant = (type) => {
//     let entry =
//       type === "both"
//         ? [pendingParticipant.id, pendingParticipant.email]
//         : [pendingParticipant.email];

//     setFormData((prev) => ({
//       ...prev,
//       participants: [...prev.participants, entry],
//     }));

//     setShowNotifyModal(false);
//     setPendingParticipant(null);
//     setParticipantEmail("");
//   };

//   return (
//     <form
//       onSubmit={handleSubmit}
//       className="grid gap-4 p-4 w-full max-w-4xl mx-auto bg-white rounded-lg shadow-sm dark:bg-gray-800"
//     >
//       {/* Title Field */}
//       <div className="w-full">
//         <label className="block text-sm font-medium text-gray-700 mb-1 dark:text-white">
//           Title*
//         </label>
//         <input
//           type="text"
//           name="title"
//           value={formData.title}
//           onChange={handleChange}
//           required
//           className="w-full p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700"
//           placeholder="Issue title"
//         />
//       </div>

//       {/* Priority, Type, Status, Severity Row */}
//       <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 dark:text-white">
//         {/* Priority */}
//         <div className="w-full">
//           <label className="block text-sm font-medium text-gray-700 mb-1 dark:text-white">
//             Priority
//           </label>
//           <select
//             name="priority"
//             value={formData.priority}
//             onChange={handleChange}
//             className="w-full p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700"
//           >
//             <option value="Low">Low</option>
//             <option value="Medium">Medium</option>
//             <option value="High">High</option>
//           </select>
//         </div>

//         {/* Type */}
//         <div className="w-full">
//           <label className="block text-sm font-medium text-gray-700 mb-1 dark:text-white">
//             Type
//           </label>
//           <select
//             name="type"
//             value={formData.type}
//             onChange={handleChange}
//             className="w-full p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700"
//           >
//             <option value="">Select Type</option>
//             {type.map((t) => (
//               <option key={t.id} value={t.name}>
//                 {t.name}
//               </option>
//             ))}
//           </select>
//         </div>

//         {/* Status */}
//         <div className="w-full">
//           <label className="block text-sm font-medium text-gray-700 mb-1 dark:text-white">
//             Status
//           </label>
//           <select
//             name="statusName"
//             value={formData.statusName}
//             onChange={(e) => {
//               const selectedStatus = statuses.find(
//                 (status) => status.name === e.target.value
//               );
//               setFormData({
//                 ...formData,
//                 statusName: e.target.value,
//                 statusColor: selectedStatus ? selectedStatus.color : "",
//               });
//             }}
//             className="w-full p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700"
//           >
//             <option value="">Select Status</option>
//             {statuses
//             .filter(status => status.active === true)
//             .map((status) => (
//               <option key={status.id} value={status.name}>
//                 {status.name}
//               </option>
//             ))}
//           </select>
//         </div>

//         {/* Severity */}
//         <div className="w-full">
//           <label className="block text-sm font-medium text-gray-700 mb-1 dark:text-white">
//             Severity
//           </label>
//           <select
//             name="severity"
//             value={formData.severity}
//             onChange={handleChange}
//             className="w-full p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700"
//           >
//             <option value="">Select Severity</option>
//             {severities.map((severity) => (
//               <option key={severity.id} value={severity.name}>
//                 {severity.name}
//               </option>
//             ))}
//           </select>
//         </div>
//       </div>

//       {/* Environment and Expected Fix Date */}
//       <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
//         {/* Environment */}
//         <div className="w-full">
//           <label className="block text-sm font-medium text-gray-700 mb-1 dark:text-white">
//             Environment
//           </label>
//           <select
//             name="environment"
//             value={formData.environment}
//             onChange={handleChange}
//             className="w-full p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700"
//           >
//             <option value="">Select Environment</option>
//             {environments.map((env) => (
//               <option key={env.id} value={env.name}>
//                 {env.name}
//               </option>
//             ))}
//           </select>
//         </div>

//         {/* Expected Fix Date */}
//         <div className="w-full">
//           <label className="block text-sm font-medium text-gray-700 mb-1 dark:text-white">
//             Expected Fix Date
//           </label>
//           <input
//             type="date"
//             name="expectedFixDate"
//             value={formData.expectedFixDate}
//             onChange={handleChange}
//             min={new Date().toISOString().split("T")[0]}
//             className="w-full p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700"
//           />
//         </div>
//       </div>

//       {/* Assign To */}
//       <div className="w-full">
//   <label className="block text-sm font-medium text-gray-700 mb-1 dark:text-white">
//     Assign To
//   </label>
//   <Select
//     isMulti
//     name="assignedToJson"
//     options={users.map((user) => ({
//       value: user.id,
//       label: `${user.fname} ${user.lname}`,
//     }))}
//     value={
//       formData.assignedToJson
//         ? JSON.parse(formData.assignedToJson).map(user => ({
//             value: user.id,
//             label: user.name
//           }))
//         : []
//     }
//     onChange={handleAssignedUsersChange}
//     className="basic-multi-select"
//     classNamePrefix="select"
//     styles={{
//       control: (base, state) => ({
//         ...base,
//         backgroundColor: document.documentElement.classList.contains('dark') 
//           ? '#374151' // dark:bg-gray-700
//           : base.backgroundColor,
//         borderColor: document.documentElement.classList.contains('dark') 
//           ? '#4B5563' // dark:border-gray-600
//           : base.borderColor,
//         '&:hover': {
//           borderColor: document.documentElement.classList.contains('dark') 
//             ? '#6B7280' // dark:hover:border-gray-500
//             : base['&:hover'].borderColor,
//         },
//         boxShadow: state.isFocused 
//           ? (document.documentElement.classList.contains('dark')
//               ? '0 0 0 1px #6366F1' // dark:focus:ring-indigo-500
//               : '0 0 0 1px #3B82F6') // focus:ring-blue-500
//           : base.boxShadow,
//       }),
//       menu: (base) => ({
//         ...base,
//         backgroundColor: document.documentElement.classList.contains('dark') 
//           ? '#1F2937' // dark:bg-gray-800
//           : base.backgroundColor,
//       }),
//       option: (base, state) => ({
//         ...base,
//         backgroundColor: state.isFocused 
//           ? (document.documentElement.classList.contains('dark')
//               ? '#4B5563' // dark:bg-gray-600
//               : '#E5E7EB') // bg-gray-200
//           : state.isSelected
//           ? (document.documentElement.classList.contains('dark')
//               ? '#6366F1' // dark:bg-indigo-500
//               : '#3B82F6') // bg-blue-500
//           : base.backgroundColor,
//         color: document.documentElement.classList.contains('dark')
//           ? '#F9FAFB' // dark:text-white
//           : base.color,
//       }),
//       multiValue: (base) => ({
//         ...base,
//         backgroundColor: document.documentElement.classList.contains('dark')
//           ? '#4B5563' // dark:bg-gray-600
//           : '#E5E7EB', // bg-gray-200
//       }),
//       multiValueLabel: (base) => ({
//         ...base,
//         color: document.documentElement.classList.contains('dark')
//           ? '#F9FAFB' // dark:text-white
//           : base.color,
//       }),
//       multiValueRemove: (base) => ({
//         ...base,
//         color: document.documentElement.classList.contains('dark')
//           ? '#F9FAFB' // dark:text-white
//           : base.color,
//         ':hover': {
//           backgroundColor: document.documentElement.classList.contains('dark')
//             ? '#6B7280' // dark:hover:bg-gray-500
//             : '#D1D5DB', // hover:bg-gray-300
//         },
//       }),
//       input: (base) => ({
//         ...base,
//         color: document.documentElement.classList.contains('dark')
//           ? '#F9FAFB' // dark:text-white
//           : base.color,
//       }),
//       singleValue: (base) => ({
//         ...base,
//         color: document.documentElement.classList.contains('dark')
//           ? '#F9FAFB' // dark:text-white
//           : base.color,
//       }),
//       placeholder: (base) => ({
//         ...base,
//         color: document.documentElement.classList.contains('dark')
//           ? '#9CA3AF' // dark:text-gray-400
//           : base.color,
//       }),
//     }}
//   />
// </div>

//       {/* Tags */}
//       <div className="w-full">
//         <label className="block text-sm font-medium text-gray-700 mb-1 dark:text-white">
//           Tags
//         </label>
//         <div className="flex flex-wrap gap-2 mb-2">
//           {formData.tags.map((tag, index) => (
//             <div
//               key={index}
//               className="flex items-center bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-sm dark:bg-blue-900 dark:text-blue-200"
//             >
//               {tag}
//               <button
//                 type="button"
//                 onClick={() => removeTag(index)}
//                 className="ml-2 text-blue-600 hover:text-blue-800 dark:text-blue-200 dark:hover:text-blue-400"
//               >
//                 ×
//               </button>
//             </div>
//           ))}
//         </div>
//         <input
//           type="text"
//           onKeyDown={handleTagsChange}
//           onBlur={(e) => {
//             if (e.target.value.trim()) {
//               setFormData((prev) => ({
//                 ...prev,
//                 tags: [...prev.tags, e.target.value.trim()],
//               }));
//               e.target.value = "";
//             }
//           }}
//           className="w-full p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700"
//           placeholder="Type tag and press Enter or comma"
//         />
//       </div>

//       {/* Participant Email Input */}
//       <div className="w-full">
//         <label className="block text-sm font-medium text-gray-700 mb-1 dark:text-white">
//           Participant Email
//         </label>
//         <div className="flex gap-2">
//           <input
//             type="email"
//             value={participantEmail}
//             onChange={(e) => {
//               setParticipantEmail(e.target.value);
//               setEmailError("");
//             }}
//             className={`w-full p-2 border rounded-md dark:bg-gray-700 ${
//               emailError ? "border-red-500" : "border-gray-300"
//             }`}
//             placeholder="Add participant email"
//           />
//           <button
//             type="button"
//             onClick={handleAddParticipant}
//             className="px-3 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
//           >
//             Add
//           </button>
//         </div>
//         {emailError && (
//           <p className="mt-1 text-sm text-red-600 dark:text-red-400">
//             {emailError}
//           </p>
//         )}
//       </div>

//       {/* List of Added Participants */}
//       {formData.participants.length > 0 && (
//         <div className="mt-2 space-y-1">
//           {formData.participants.map((participant, index) => {
//             const email = Array.isArray(participant)
//               ? participant[1] || participant[0]
//               : participant;
//             return (
//               <div
//                 key={index}
//                 className="flex items-center justify-between bg-gray-100 dark:bg-gray-700 px-3 py-1 rounded-md"
//               >
//                 <span className="text-sm text-gray-800 dark:text-white">
//                   {email}
//                 </span>
//                 <button
//                   type="button"
//                   onClick={() => {
//                     setFormData((prev) => ({
//                       ...prev,
//                       participants: prev.participants.filter(
//                         (_, i) => i !== index
//                       ),
//                     }));
//                   }}
//                   className="text-red-500 hover:text-red-700 text-sm"
//                   title="Remove"
//                 >
//                   ❌
//                 </button>
//               </div>
//             );
//           })}
//         </div>
//       )}

//       {/* Description */}
//       <div className="w-full">
//         <label className="block text-sm font-medium text-gray-700 mb-1 dark:text-white">
//           Description*
//         </label>
//         <textarea
//           name="description"
//           value={formData.description}
//           onChange={handleChange}
//           required
//           className="w-full p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500 min-h-[100px] dark:bg-gray-700"
//           placeholder="Detailed description of the issue"
//         ></textarea>
//       </div>

//       {/* Reproducible Steps */}
//       <div className="w-full">
//         <label className="block text-sm font-medium text-gray-700 mb-1 dark:text-white">
//           Reproducible Steps
//         </label>
//         <textarea
//           name="reproducibleSteps"
//           value={formData.reproducibleSteps}
//           onChange={handleChange}
//           className="w-full p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500 min-h-[100px] dark:bg-gray-700"
//           placeholder="Steps to reproduce the issue"
//         ></textarea>
//       </div>

//       {/* File Upload */}
//       <div className="w-full">
//   <label className="block text-sm font-medium text-gray-700 mb-1 dark:text-white">
//     Upload Files
//   </label>
//   <input
//     ref={fileInputRef}
//     type="file"
//     name="files"
//     multiple
//     accept=".png,.jpg,.jpeg,.pdf,.doc,.docx,.txt,.csv,.xls,.xlsx"
//     onChange={handleFileChange}
//     className="w-full p-2 text-sm text-gray-700 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500 file:mr-4 file:py-2 file:px-4 file:rounded file:border-0 file:text-sm file:font-semibold file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100 dark:bg-gray-700"
//   />
//   <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">
//     PNG, JPG, PDF, DOC, DOCX, TXT, CSV, XLS, XLSX — max 10 MB. Multiple files allowed.
//     You can also paste files directly.
//   </p>
  
//   {/* Display existing attachments */}
//   {formData.attachments && formData.attachments.length > 0 && (
//     <div className="mt-2 space-y-2">
//       <p className="text-sm font-medium text-gray-700 dark:text-white">Existing Attachments:</p>
//       {formData.attachments.map((attachment, index) => (
//         <div key={`attachment-${index}`} className="flex items-center justify-between bg-gray-100 dark:bg-gray-700 px-3 py-2 rounded-md">
//           <span className="text-sm text-gray-800 dark:text-white truncate max-w-xs">
//             {attachment.split('_').slice(1).join('_')}
//           </span>
//           <button
//             type="button"
//             onClick={() => removeAttachment(index)}
//             className="text-red-500 hover:text-red-700 text-sm"
//             title="Remove"
//           >
//             ❌
//           </button>
//         </div>
//       ))}
//     </div>
//   )}
  
//   {/* Display new files to be uploaded */}
//   {formData.files.length > 0 && (
//     <div className="mt-2 space-y-2">
//       <p className="text-sm font-medium text-gray-700 dark:text-white">New Files:</p>
//       {formData.files.map((file, index) => (
//         <div key={`file-${index}`} className="flex items-center justify-between bg-gray-100 dark:bg-gray-700 px-3 py-2 rounded-md">
//           <span className="text-sm text-gray-800 dark:text-white truncate max-w-xs">
//             {file.name} ({Math.round(file.size / 1024)} KB)
//           </span>
//           <button
//             type="button"
//             onClick={() => removeFile(index)}
//             className="text-red-500 hover:text-red-700 text-sm"
//             title="Remove"
//           >
//             ❌
//           </button>
//         </div>
//       ))}
//     </div>
//   )}
// </div>

//       {/* Submit Button */}
//       <button
//         type="submit"
//         disabled={isSubmitting}
//         className={`w-full p-2 text-white rounded font-semibold transition-colors duration-200 ${
//           isSubmitting
//             ? "bg-gray-400 cursor-not-allowed"
//             : editData 
//               ? "bg-green-600 hover:bg-green-700" 
//               : "bg-blue-600 hover:bg-blue-700"
//         }`}
//       >
//         {isSubmitting 
//           ? editData 
//             ? "Updating..." 
//             : "Creating..."
//           : editData 
//             ? "Update Issue" 
//             : "Create Issue"}
//       </button>

//       {showNotifyModal && (
//         <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
//           <div className="bg-white p-6 rounded-lg shadow-xl w-full max-w-md text-center dark:bg-gray-900 dark:text-white">
//             <div className="flex justify-end">
//               <button
//                 type="button"
//                 onClick={() => {
//                   setShowNotifyModal(false);
//                   setOpenForm?.(null);
//                 }}
//                 className="text-gray-600 hover:text-red-600 text-xl font-bold"
//                 aria-label="Close"
//               >
//                 &times;
//               </button>
//             </div>
//             <h2 className="text-lg font-semibold mb-4">
//               Notification Preference
//             </h2>
//             <p className="mb-4">
//               How would you like to notify{" "}
//               <span className="font-bold">{pendingParticipant.email}</span>?
//             </p>
//             <div className="flex justify-around gap-4">
//               <button
//                 onClick={() => confirmParticipant("both")}
//                 className="px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700"
//               >
//                 Notification + Email
//               </button>
//               <button
//                 onClick={() => confirmParticipant("email")}
//                 className="px-4 py-2 bg-yellow-500 text-white rounded hover:bg-yellow-600"
//               >
//                 Email Only
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </form>
//   );
// }



// import { useContext, useState, useEffect, useRef } from "react";
// import axios from "axios";
// import { AuthContext } from "../context/AuthContext";
// import { API_URL } from "../../Constants";
// import Select from "react-select";
// import { toast } from "react-toastify";

// export default function IssueForm({
//   showIssueForm,
//   onIssueCreated,
//   setOpenForm = null,
//   editData = null,
//   onIssueUpdated,
// }) {
//   const { user } = useContext(AuthContext);
//   const [users, setUsers] = useState([]);
//   const [statuses, setStatuses] = useState([]);
//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const [emailError, setEmailError] = useState("");
//   const [formData, setFormData] = useState({
//     companyId: user.accountType === "COMPANY" ? user.id : user.companyId,
//     title: "",
//     description: "",
//     statusName: "",
//     statusColor: "",
//     priority: "Low",
//     severity: "",
//     type: "",
//     environment: "",
//     tags: [],
//     expectedFixDate: "",
//     reportedById: user?.id,
//     reportedByName: user?.name,
//     assignedToJson: JSON.stringify([]),
//     participants: [],
//     reproducibleSteps: "",
//     taskId: "",
//     projectId: "",
//     files: [],
//   });
//   const [participantEmail, setParticipantEmail] = useState("");
//   const [showNotifyModal, setShowNotifyModal] = useState(false);
//   const [pendingParticipant, setPendingParticipant] = useState(null);
//   const fileInputRef = useRef(null);
//   const [severities, setSeverities] = useState([]);
//   const [environments, setEnvironments] = useState([]);
//   const [type, setType] = useState([]);

//   // Allowed mime types & max size (bytes)
//   const ALLOWED_TYPES = [
//     "image/png",
//     "image/jpeg",
//     "application/pdf",
//     "application/msword", // .doc
//     "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // .docx
//     "text/plain", // .txt
//     "text/csv", // .csv
//     "application/vnd.ms-excel", // .xls
//     "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // .xlsx
//   ];
//   const MAX_SIZE = 10 * 1024 * 1024; // 10 MB

//   // Clipboard-paste listener (mount once)
//   useEffect(() => {
//     function handlePaste(e) {
//       const files = [];
//       const items = [...e.clipboardData.items];
      
//       for (const item of items) {
//         if (item.kind === 'file') {
//           const file = item.getAsFile();
//           if (file && ALLOWED_TYPES.includes(file.type)) {
//             if (file.size > MAX_SIZE) {
//               toast.error(`${file.name} exceeds 10 MB limit`);
//               continue;
//             }
//             files.push(file);
//           }
//         }
//       }

//       if (files.length > 0) {
//         setFormData(prev => ({
//           ...prev,
//           files: [...prev.files, ...files]
//         }));
//         toast.success(`Added ${files.length} file(s) from clipboard`);
//       }
//     }

//     window.addEventListener("paste", handlePaste);
//     return () => window.removeEventListener("paste", handlePaste);
//   }, []);

//   useEffect(() => {
//     async function fetchInitialData() {
//       const companyId =
//         user?.accountType === "COMPANY" ? user.id : user?.companyId;

//       try {
//         // Fetch statuses
//         const statusResponse = await axios.get(
//           `${API_URL}/api/issueStatus/company/${companyId}`,
//           {
//             headers: {
//               authorization: `Bearer ${localStorage.getItem("token")}`,
//             },
//           }
//         );

//         // Fetch types
//         const typeResponse = await axios.get(
//           `${API_URL}/api/issueType/company/${companyId}`,
//           {
//             headers: {
//               authorization: `Bearer ${localStorage.getItem("token")}`,
//             },
//           }
//         );

//         // Fetch severities
//         const severityResponse = await axios.get(
//           `${API_URL}/api/severityTemplate/company/${companyId}`,
//           {
//             headers: {
//               authorization: `Bearer ${localStorage.getItem("token")}`,
//             },
//           }
//         );

//         // Fetch environments
//         const environmentResponse = await axios.get(
//           `${API_URL}/api/environment/company/${companyId}`,
//           {
//             headers: {
//               authorization: `Bearer ${localStorage.getItem("token")}`,
//             },
//           }
//         );

//         setStatuses(statusResponse.data);
//         setType(typeResponse.data);
//         setSeverities(severityResponse.data);
//         setEnvironments(environmentResponse.data);
//       } catch (error) {
//         console.error("Error fetching initial data:", error);
//       }
//     }
//     fetchInitialData();
//   }, [user]);

//   // Fetch Users
//   useEffect(() => {
//     async function fetchUsers() {
//       if (!user?.id || !user?.accountType) return;
//       const url =
//         user?.accountType === "COMPANY"
//           ? `${API_URL}/api/companyuser/getByUserId?userId=${user.id}&accountType=${user.accountType}`
//           : `${API_URL}/api/companyuser/getSameAndSubordinateUsers?userId=${user.id}&accountType=${user.accountType}`;

//       try {
//         const response = await fetch(url, {
//           method: "GET",
//           headers: {
//             authorization: `Bearer ${localStorage.getItem("token")}`,
//             "Content-Type": "application/json",
//           },
//         });

//         if (!response.ok) {
//           throw new Error(`HTTP error! Status: ${response.status}`);
//         }

//         const data = await response.json();
//         setUsers(data);
//       } catch (error) {
//         console.error("Error fetching users:", error);
//       }
//     }
//     fetchUsers();
//   }, [user]);

//   useEffect(() => {
//     if (editData) {
//       setFormData({
//         companyId: editData.companyId,
//         title: editData.title || "",
//         description: editData.description || "",
//         statusName: editData.statusName || "",
//         statusColor: editData.statusColor || "",
//         priority: editData.priority || "Low",
//         severity: editData.severity || "",
//         type: editData.type || "",
//         environment: editData.environment || "",
//         tags: editData.tags || [],
//         expectedFixDate: editData.expectedFixDate || "",
//         reportedById: editData.reportedById || user?.id,
//         reportedByName: editData.reportedByName || user?.name,
//         assignedToJson: editData.assignedTo 
//           ? JSON.stringify(editData.assignedTo)
//           : JSON.stringify([]),
//         participants: editData.participants || [],
//         reproducibleSteps: editData.reproducibleSteps || "",
//         taskId: editData.taskId || "",
//         projectId: editData.projectId || "",
//         attachments: editData.attachments || [], 
//         files: [], 
//       });
      
//       const participantEmails = editData.participants?.map(p => 
//         Array.isArray(p) ? p[1] || p[0] : p
//       ) || [];
//       setParticipantEmail(participantEmails.join(', '));
//     }
//   }, [editData, user?.id, user?.name]);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData({ ...formData, [name]: value });
//   };

//   const handleAssignedUsersChange = (selectedOptions) => {
//     const assignedUsers = selectedOptions.map((option) => ({
//       id: option.value,
//       name: option.label,
//     }));

//     setFormData({
//       ...formData,
//       assignedToJson: JSON.stringify(assignedUsers),
//     });
//   };

//   const handleTagsChange = (e) => {
//     const value = e.target.value;
//     if (e.key === "Enter" || e.key === ",") {
//       e.preventDefault();
//       if (value.trim()) {
//         setFormData((prev) => ({
//           ...prev,
//           tags: [...prev.tags, value.trim()],
//         }));
//         e.target.value = "";
//       }
//     }
//   };

//   const removeTag = (indexToRemove) => {
//     setFormData((prev) => ({
//       ...prev,
//       tags: prev.tags.filter((_, index) => index !== indexToRemove),
//     }));
//   };

//   const handleFileChange = (e) => {
//     const files = Array.from(e.target.files);
//     const validFiles = [];
    
//     for (const file of files) {
//       if (!ALLOWED_TYPES.includes(file.type)) {
//         toast.error(`Unsupported file type: ${file.name}`);
//         continue;
//       }
//       if (file.size > MAX_SIZE) {
//         toast.error(`${file.name} exceeds 10 MB limit`);
//         continue;
//       }
//       validFiles.push(file);
//     }

//     if (validFiles.length > 0) {
//       setFormData(prev => ({
//         ...prev,
//         files: [...prev.files, ...validFiles]
//       }));
//     }
//   };

//   const removeFile = (indexToRemove) => {
//     setFormData(prev => ({
//       ...prev,
//       files: prev.files.filter((_, index) => index !== indexToRemove)
//     }));
//   };

//   const removeAttachment = (indexToRemove) => {
//     setFormData(prev => ({
//       ...prev,
//       attachments: prev.attachments.filter((_, index) => index !== indexToRemove)
//     }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setIsSubmitting(true);

//     try {
//       const formDataToSend = new FormData();
      
//       // Append all form data to FormData object
//       Object.keys(formData).forEach((key) => {
//         if (formData[key] !== null && formData[key] !== undefined) {
//           if (key === "files" && formData.files.length > 0) {
//             formData.files.forEach(file => {
//               formDataToSend.append("files", file);
//             });
//           } else if (key === "tags" && formData.tags.length > 0) {
//             formData.tags.forEach(tag => {
//               formDataToSend.append("tags", tag);
//             });
//           } else if (key === "participants" && formData.participants.length > 0) {
//             formData.participants.forEach(participant => {
//               formDataToSend.append("participants", participant);
//             });
//           } else {
//             formDataToSend.append(key, formData[key]);
//           }
//         }
//       });

//       let response;
//       if (editData) {
//         response = await axios.put(
//           `${API_URL}/api/issues/${editData.issueId}/updatedBy/${user.name}`,
//           formDataToSend,
//           {
//             headers: {
//               authorization: `Bearer ${localStorage.getItem("token")}`,
//               "Content-Type": "multipart/form-data",
//             },
//           }
//         );
//       } else {
//         response = await axios.post(
//           `${API_URL}/api/issues`,
//           formDataToSend,
//           {
//             headers: {
//               authorization: `Bearer ${localStorage.getItem("token")}`,
//               "Content-Type": "multipart/form-data",
//             },
//           }
//         );
//       }

//       if (response.data?.status === "Successful") {
//         toast.success(response.data.message);
        
//         // Reset form
//         setFormData({
//           companyId: user.accountType === "COMPANY" ? user.id : user.companyId,
//           title: "",
//           description: "",
//           statusName: "",
//           statusColor: "",
//           priority: "Low",
//           severity: "",
//           type: "",
//           environment: "",
//           tags: [],
//           expectedFixDate: "",
//           reportedById: user?.id,
//           reportedByName: user?.name,
//           assignedToJson: JSON.stringify([]),
//           participants: [],
//           reproducibleSteps: "",
//           taskId: "",
//           projectId: "",
//           files: [],
//           attachments: [],
//         });

//         // Close the form
//         if (typeof showIssueForm === 'function') {
//           showIssueForm(false);
//         }
//         if (typeof setOpenForm === 'function') {
//           setOpenForm(null);
//         }

//         // Trigger update callbacks
//         if (editData) {
//           if (typeof onIssueUpdated === 'function') {
//             onIssueUpdated(response.data);
//           }
//         } else {
//           window.dispatchEvent(new Event("issueCreated"));
//           if (typeof onIssueCreated === 'function') {
//             onIssueCreated(response.data);
//           }
//         }
        
//         showIssueForm?.(false);
//         setOpenForm?.(null);
//       } else {
//         toast.error(response.data?.message);
//       }
//     } catch (error) {
//       console.error("Issue operation error:", error);
//       toast.error(error.response?.data?.message || error.message);
//     } finally {
//       setIsSubmitting(false);
//     }
//   };

//   const handleAddParticipant = () => {
//     setEmailError("");

//     if (!participantEmail) {
//       setEmailError("Please enter an email address");
//       return;
//     }

//     const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//     if (!emailRegex.test(participantEmail)) {
//       setEmailError("Please enter a valid email address");
//       return;
//     }

//     const isDuplicate = formData.participants.some((participant) => {
//       const email = Array.isArray(participant)
//         ? participant[1] || participant[0]
//         : participant;
//       return email.toLowerCase() === participantEmail.toLowerCase();
//     });

//     if (isDuplicate) {
//       setEmailError("This email is already added");
//       return;
//     }

//     const matchedUser = users.find(
//       (u) => u.email.toLowerCase() === participantEmail.toLowerCase()
//     );
//     if (matchedUser) {
//       setPendingParticipant({ id: matchedUser.id, email: participantEmail });
//       setShowNotifyModal(true);
//     } else {
//       setFormData((prev) => ({
//         ...prev,
//         participants: [...prev.participants, [participantEmail]],
//       }));
//       setParticipantEmail("");
//     }
//   };

//   const confirmParticipant = (type) => {
//     let entry =
//       type === "both"
//         ? [pendingParticipant.id, pendingParticipant.email]
//         : [pendingParticipant.email];

//     setFormData((prev) => ({
//       ...prev,
//       participants: [...prev.participants, entry],
//     }));

//     setShowNotifyModal(false);
//     setPendingParticipant(null);
//     setParticipantEmail("");
//   };

//   return (
//     <>
//       <style>{`@import url('https://fonts.googleapis.com/css2?family=Sora:wght@600;700&family=Inter:wght@400;500;600&display=swap'); .cfg-heading{font-family:'Sora',sans-serif;color:#1F2937;} .cfg-font{font-family:'Inter',sans-serif;}`}</style>
//       <form
//         onSubmit={handleSubmit}
//         className="grid gap-5 p-4 w-full max-w-4xl mx-auto bg-white cfg-font rounded-lg border border-[#E5E7EB] dark:border-gray-700 dark:bg-gray-800"
//       >
//         {/* Title Field */}
//         <div className="w-full">
//           <label className="block text-sm font-semibold text-[#374151] mb-1.5 dark:text-gray-200">
//             Title*
//           </label>
//           <input
//             type="text"
//             name="title"
//             value={formData.title}
//             onChange={handleChange}
//             required
//             className="w-full p-2.5 border border-[#E5E7EB] rounded-md focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7] dark:bg-gray-700 dark:border-gray-600 dark:text-white"
//             placeholder="Issue title"
//           />
//         </div>

//         {/* Priority, Type, Status, Severity Row */}
//         <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 dark:text-white">
//           {/* Priority */}
//           <div className="w-full">
//             <label className="block text-sm font-semibold text-[#374151] mb-1.5 dark:text-gray-200">
//               Priority
//             </label>
//             <select
//               name="priority"
//               value={formData.priority}
//               onChange={handleChange}
//               className="w-full p-2.5 border border-[#E5E7EB] rounded-md focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7] dark:bg-gray-700 dark:border-gray-600 dark:text-white"
//             >
//               <option value="Low">Low</option>
//               <option value="Medium">Medium</option>
//               <option value="High">High</option>
//             </select>
//           </div>

//           {/* Type */}
//           <div className="w-full">
//             <label className="block text-sm font-semibold text-[#374151] mb-1.5 dark:text-gray-200">
//               Type
//             </label>
//             <select
//               name="type"
//               value={formData.type}
//               onChange={handleChange}
//               className="w-full p-2.5 border border-[#E5E7EB] rounded-md focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7] dark:bg-gray-700 dark:border-gray-600 dark:text-white"
//             >
//               <option value="">Select Type</option>
//               {type.map((t) => (
//                 <option key={t.id} value={t.name}>
//                   {t.name}
//                 </option>
//               ))}
//             </select>
//           </div>

//           {/* Status */}
//           <div className="w-full">
//             <label className="block text-sm font-semibold text-[#374151] mb-1.5 dark:text-gray-200">
//               Status
//             </label>
//             <select
//               name="statusName"
//               value={formData.statusName}
//               onChange={(e) => {
//                 const selectedStatus = statuses.find(
//                   (status) => status.name === e.target.value
//                 );
//                 setFormData({
//                   ...formData,
//                   statusName: e.target.value,
//                   statusColor: selectedStatus ? selectedStatus.color : "",
//                 });
//               }}
//               className="w-full p-2.5 border border-[#E5E7EB] rounded-md focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7] dark:bg-gray-700 dark:border-gray-600 dark:text-white"
//             >
//               <option value="">Select Status</option>
//               {statuses
//               .filter(status => status.active === true)
//               .map((status) => (
//                 <option key={status.id} value={status.name}>
//                   {status.name}
//                 </option>
//               ))}
//             </select>
//           </div>

//           {/* Severity */}
//           <div className="w-full">
//             <label className="block text-sm font-semibold text-[#374151] mb-1.5 dark:text-gray-200">
//               Severity
//             </label>
//             <select
//               name="severity"
//               value={formData.severity}
//               onChange={handleChange}
//               className="w-full p-2.5 border border-[#E5E7EB] rounded-md focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7] dark:bg-gray-700 dark:border-gray-600 dark:text-white"
//             >
//               <option value="">Select Severity</option>
//               {severities.map((severity) => (
//                 <option key={severity.id} value={severity.name}>
//                   {severity.name}
//                 </option>
//               ))}
//             </select>
//           </div>
//         </div>

//         {/* Environment and Expected Fix Date */}
//         <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
//           {/* Environment */}
//           <div className="w-full">
//             <label className="block text-sm font-semibold text-[#374151] mb-1.5 dark:text-gray-200">
//               Environment
//             </label>
//             <select
//               name="environment"
//               value={formData.environment}
//               onChange={handleChange}
//               className="w-full p-2.5 border border-[#E5E7EB] rounded-md focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7] dark:bg-gray-700 dark:border-gray-600 dark:text-white"
//             >
//               <option value="">Select Environment</option>
//               {environments.map((env) => (
//                 <option key={env.id} value={env.name}>
//                   {env.name}
//                 </option>
//               ))}
//             </select>
//           </div>

//           {/* Expected Fix Date */}
//           <div className="w-full">
//             <label className="block text-sm font-semibold text-[#374151] mb-1.5 dark:text-gray-200">
//               Expected Fix Date
//             </label>
//             <input
//               type="date"
//               name="expectedFixDate"
//               value={formData.expectedFixDate}
//               onChange={handleChange}
//               min={new Date().toISOString().split("T")[0]}
//               className="w-full p-2.5 border border-[#E5E7EB] rounded-md focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7] dark:bg-gray-700 dark:border-gray-600 dark:text-white"
//             />
//           </div>
//         </div>

//         {/* Assign To */}
//         <div className="w-full">
//           <label className="block text-sm font-semibold text-[#374151] mb-1.5 dark:text-gray-200">
//             Assign To
//           </label>
//           <Select
//             isMulti
//             name="assignedToJson"
//             options={users.map((user) => ({
//               value: user.id,
//               label: `${user.fname} ${user.lname}`,
//             }))}
//             value={
//               formData.assignedToJson
//                 ? JSON.parse(formData.assignedToJson).map(user => ({
//                     value: user.id,
//                     label: user.name
//                   }))
//                 : []
//             }
//             onChange={handleAssignedUsersChange}
//             className="basic-multi-select"
//             classNamePrefix="select"
//             styles={{
//               control: (base, state) => ({
//                 ...base,
//                 minHeight: "42px",
//                 backgroundColor: document.documentElement.classList.contains('dark') 
//                   ? '#374151' 
//                   : '#ffffff',
//                 borderColor: document.documentElement.classList.contains('dark') 
//                   ? '#4B5563' 
//                   : '#E5E7EB',
//                 '&:hover': {
//                   borderColor: document.documentElement.classList.contains('dark') 
//                     ? '#6B7280' 
//                     : '#8B5CF6',
//                 },
//                 boxShadow: state.isFocused 
//                   ? (document.documentElement.classList.contains('dark')
//                       ? '0 0 0 2px #8B5CF6' 
//                       : '0 0 0 2px #E9D5FF') 
//                   : base.boxShadow,
//               }),
//               menu: (base) => ({
//                 ...base,
//                 backgroundColor: document.documentElement.classList.contains('dark') 
//                   ? '#1F2937' 
//                   : base.backgroundColor,
//               }),
//               option: (base, state) => ({
//                 ...base,
//                 backgroundColor: state.isFocused 
//                   ? (document.documentElement.classList.contains('dark')
//                       ? '#4B5563' 
//                       : '#F3F4F6') 
//                   : state.isSelected
//                   ? (document.documentElement.classList.contains('dark')
//                       ? '#673AB7' 
//                       : '#673AB7') 
//                   : base.backgroundColor,
//                 color: state.isSelected 
//                   ? '#ffffff'
//                   : document.documentElement.classList.contains('dark')
//                   ? '#F9FAFB' 
//                   : '#374151',
//               }),
//               multiValue: (base) => ({
//                 ...base,
//                 backgroundColor: document.documentElement.classList.contains('dark')
//                   ? '#4B5563' 
//                   : '#F3E8FF', 
//               }),
//               multiValueLabel: (base) => ({
//                 ...base,
//                 color: document.documentElement.classList.contains('dark')
//                   ? '#F9FAFB' 
//                   : '#673AB7',
//                 fontWeight: '500',
//               }),
//               multiValueRemove: (base) => ({
//                 ...base,
//                 color: document.documentElement.classList.contains('dark')
//                   ? '#F9FAFB' 
//                   : '#673AB7',
//                 ':hover': {
//                   backgroundColor: document.documentElement.classList.contains('dark')
//                     ? '#6B7280' 
//                     : '#E9D5FF', 
//                 },
//               }),
//               input: (base) => ({
//                 ...base,
//                 color: document.documentElement.classList.contains('dark')
//                   ? '#F9FAFB' 
//                   : '#374151',
//               }),
//               placeholder: (base) => ({
//                 ...base,
//                 color: document.documentElement.classList.contains('dark')
//                   ? '#9CA3AF' 
//                   : '#9CA3AF',
//               }),
//             }}
//           />
//         </div>

//         {/* Tags */}
//         <div className="w-full">
//           <label className="block text-sm font-semibold text-[#374151] mb-1.5 dark:text-gray-200">
//             Tags
//           </label>
//           <div className="flex flex-wrap gap-2 mb-2">
//             {formData.tags.map((tag, index) => (
//               <div
//                 key={index}
//                 className="flex items-center bg-[#F3E8FF] text-[#673AB7] font-medium px-3 py-1 rounded-full text-sm dark:bg-purple-900 dark:text-purple-200 border border-[#E9D5FF] dark:border-purple-700"
//               >
//                 {tag}
//                 <button
//                   type="button"
//                   onClick={() => removeTag(index)}
//                   className="ml-2 text-[#673AB7] hover:text-[#5E35A6] dark:text-purple-200 dark:hover:text-purple-400 font-bold"
//                 >
//                   ×
//                 </button>
//               </div>
//             ))}
//           </div>
//           <input
//             type="text"
//             onKeyDown={handleTagsChange}
//             onBlur={(e) => {
//               if (e.target.value.trim()) {
//                 setFormData((prev) => ({
//                   ...prev,
//                   tags: [...prev.tags, e.target.value.trim()],
//                 }));
//                 e.target.value = "";
//               }
//             }}
//             className="w-full p-2.5 border border-[#E5E7EB] rounded-md focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7] dark:bg-gray-700 dark:border-gray-600 dark:text-white"
//             placeholder="Type tag and press Enter or comma"
//           />
//         </div>

//         {/* Participant Email Input */}
//         <div className="w-full">
//           <label className="block text-sm font-semibold text-[#374151] mb-1.5 dark:text-gray-200">
//             Participant Email
//           </label>
//           <div className="flex gap-2">
//             <input
//               type="email"
//               value={participantEmail}
//               onChange={(e) => {
//                 setParticipantEmail(e.target.value);
//                 setEmailError("");
//               }}
//               className={`w-full p-2.5 border rounded-md focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7] dark:bg-gray-700 dark:text-white ${
//                 emailError ? "border-[#EF4444]" : "border-[#E5E7EB] dark:border-gray-600"
//               }`}
//               placeholder="Add participant email"
//             />
//             <button
//               type="button"
//               onClick={handleAddParticipant}
//               className="px-4 py-2.5 bg-[#673AB7] text-white font-semibold rounded-md hover:bg-[#5E35A6] transition"
//             >
//               Add
//             </button>
//           </div>
//           {emailError && (
//             <p className="mt-1 text-sm text-[#EF4444] dark:text-red-400">
//               {emailError}
//             </p>
//           )}
//         </div>

//         {/* List of Added Participants */}
//         {formData.participants.length > 0 && (
//           <div className="mt-1 space-y-2">
//             {formData.participants.map((participant, index) => {
//               const email = Array.isArray(participant)
//                 ? participant[1] || participant[0]
//                 : participant;
//               return (
//                 <div
//                   key={index}
//                   className="flex items-center justify-between bg-[#F3F4F6] border border-[#E5E7EB] dark:border-gray-600 dark:bg-gray-700 px-3 py-2 rounded-md"
//                 >
//                   <span className="text-sm font-medium text-[#374151] dark:text-gray-200">
//                     {email}
//                   </span>
//                   <button
//                     type="button"
//                     onClick={() => {
//                       setFormData((prev) => ({
//                         ...prev,
//                         participants: prev.participants.filter(
//                           (_, i) => i !== index
//                         ),
//                       }));
//                     }}
//                     className="text-[#EF4444] hover:text-[#B91C1C] text-sm"
//                     title="Remove"
//                   >
//                     ❌
//                   </button>
//                 </div>
//               );
//             })}
//           </div>
//         )}

//         {/* Description */}
//         <div className="w-full">
//           <label className="block text-sm font-semibold text-[#374151] mb-1.5 dark:text-gray-200">
//             Description*
//           </label>
//           <textarea
//             name="description"
//             value={formData.description}
//             onChange={handleChange}
//             required
//             className="w-full p-2.5 border border-[#E5E7EB] rounded-md focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7] min-h-[120px] dark:bg-gray-700 dark:border-gray-600 dark:text-white"
//             placeholder="Detailed description of the issue"
//           ></textarea>
//         </div>

//         {/* Reproducible Steps */}
//         <div className="w-full">
//           <label className="block text-sm font-semibold text-[#374151] mb-1.5 dark:text-gray-200">
//             Reproducible Steps
//           </label>
//           <textarea
//             name="reproducibleSteps"
//             value={formData.reproducibleSteps}
//             onChange={handleChange}
//             className="w-full p-2.5 border border-[#E5E7EB] rounded-md focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7] min-h-[120px] dark:bg-gray-700 dark:border-gray-600 dark:text-white"
//             placeholder="Steps to reproduce the issue"
//           ></textarea>
//         </div>

//         {/* File Upload */}
//         <div className="w-full border border-[#E5E7EB] p-4 rounded-md dark:border-gray-700">
//           <label className="block text-sm font-semibold text-[#374151] mb-2 dark:text-gray-200">
//             Upload Files
//           </label>
//           <input
//             ref={fileInputRef}
//             type="file"
//             name="files"
//             multiple
//             accept=".png,.jpg,.jpeg,.pdf,.doc,.docx,.txt,.csv,.xls,.xlsx"
//             onChange={handleFileChange}
//             className="w-full text-sm text-[#6B7280] dark:text-gray-300 file:mr-4 file:py-2 file:px-4 file:rounded-md file:border-0 file:text-sm file:font-semibold file:bg-[#F3E8FF] file:text-[#673AB7] hover:file:bg-[#E9D5FF] transition dark:file:bg-purple-900/50 dark:file:text-purple-300"
//           />
//           <p className="mt-2 text-xs text-[#6B7280] dark:text-gray-400">
//             PNG, JPG, PDF, DOC, DOCX, TXT, CSV, XLS, XLSX — max 10 MB. Multiple files allowed.
//             You can also paste files directly.
//           </p>
          
//           {/* Display existing attachments */}
//           {formData.attachments && formData.attachments.length > 0 && (
//             <div className="mt-4 space-y-2">
//               <p className="text-sm font-semibold text-[#374151] dark:text-gray-200 border-b border-[#E5E7EB] dark:border-gray-600 pb-1">Existing Attachments:</p>
//               {formData.attachments.map((attachment, index) => (
//                 <div key={`attachment-${index}`} className="flex items-center justify-between bg-[#F3F4F6] dark:bg-gray-700 border border-[#E5E7EB] dark:border-gray-600 px-3 py-2 rounded-md">
//                   <span className="text-sm font-medium text-[#374151] dark:text-gray-200 truncate max-w-xs">
//                     {attachment.split('_').slice(1).join('_')}
//                   </span>
//                   <button
//                     type="button"
//                     onClick={() => removeAttachment(index)}
//                     className="text-[#EF4444] hover:text-[#B91C1C] text-sm"
//                     title="Remove"
//                   >
//                     ❌
//                   </button>
//                 </div>
//               ))}
//             </div>
//           )}
          
//           {/* Display new files to be uploaded */}
//           {formData.files.length > 0 && (
//             <div className="mt-4 space-y-2">
//               <p className="text-sm font-semibold text-[#374151] dark:text-gray-200 border-b border-[#E5E7EB] dark:border-gray-600 pb-1">New Files:</p>
//               {formData.files.map((file, index) => (
//                 <div key={`file-${index}`} className="flex items-center justify-between bg-[#F3F4F6] dark:bg-gray-700 border border-[#E5E7EB] dark:border-gray-600 px-3 py-2 rounded-md">
//                   <span className="text-sm font-medium text-[#374151] dark:text-gray-200 truncate max-w-xs">
//                     {file.name} ({Math.round(file.size / 1024)} KB)
//                   </span>
//                   <button
//                     type="button"
//                     onClick={() => removeFile(index)}
//                     className="text-[#EF4444] hover:text-[#B91C1C] text-sm"
//                     title="Remove"
//                   >
//                     ❌
//                   </button>
//                 </div>
//               ))}
//             </div>
//           )}
//         </div>

//         {/* Submit Button */}
//         <button
//           type="submit"
//           disabled={isSubmitting}
//           className={`w-full p-3 mt-2 text-white rounded-md font-bold text-base shadow-md transition-colors duration-200 ${
//             isSubmitting
//               ? "bg-[#9CA3AF] cursor-not-allowed shadow-none"
//               : editData 
//                 ? "bg-[#10B981] hover:bg-[#059669]" 
//                 : "bg-[#673AB7] hover:bg-[#5E35A6]"
//           }`}
//         >
//           {isSubmitting 
//             ? editData 
//               ? "Updating..." 
//               : "Creating..."
//             : editData 
//               ? "Update Issue" 
//               : "Create Issue"}
//         </button>

//         {showNotifyModal && (
//           <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50">
//             <div className="bg-white p-6 rounded-xl shadow-2xl w-full max-w-md text-center dark:bg-gray-800 dark:text-white border border-[#E5E7EB] dark:border-gray-700">
//               <div className="flex justify-end">
//                 <button
//                   type="button"
//                   onClick={() => {
//                     setShowNotifyModal(false);
//                     setOpenForm?.(null);
//                   }}
//                   className="text-[#6B7280] hover:text-[#EF4444] dark:hover:text-red-400 text-xl font-bold transition"
//                   aria-label="Close"
//                 >
//                   &times;
//                 </button>
//               </div>
//               <h2 className="text-xl font-bold cfg-heading text-[#1F2937] dark:text-white mb-4">
//                 Notification Preference
//               </h2>
//               <p className="mb-6 text-[#374151] dark:text-gray-300">
//                 How would you like to notify{" "}
//                 <span className="font-bold text-[#673AB7] dark:text-[#E9D5FF]">{pendingParticipant.email}</span>?
//               </p>
//               <div className="flex justify-around gap-4">
//                 <button
//                   onClick={() => confirmParticipant("both")}
//                   className="px-4 py-2 bg-[#10B981] text-white font-semibold rounded-md hover:bg-[#059669] shadow-sm transition w-full"
//                 >
//                   Notification + Email
//                 </button>
//                 <button
//                   onClick={() => confirmParticipant("email")}
//                   className="px-4 py-2 bg-[#F59E0B] text-white font-semibold rounded-md hover:bg-[#D97706] shadow-sm transition w-full"
//                 >
//                   Email Only
//                 </button>
//               </div>
//             </div>
//           </div>
//         )}
//       </form>
//     </>
//   );
// }







import { useContext, useState, useEffect, useRef } from "react";
import axios from "axios";
import { AuthContext } from "../context/AuthContext";
import { API_URL } from "../../Constants";
import Select from "react-select";
import { toast } from "react-toastify";

export default function IssueForm({
  showIssueForm,
  onIssueCreated,
  setOpenForm = null,
  editData = null,
  onIssueUpdated,
}) {
  const { user } = useContext(AuthContext);
  const [users, setUsers] = useState([]);
  const [statuses, setStatuses] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [emailError, setEmailError] = useState("");
  const [formData, setFormData] = useState({
    companyId: user.accountType === "COMPANY" ? user.id : user.companyId,
    title: "",
    description: "",
    statusName: "",
    statusColor: "",
    priority: "Low",
    severity: "",
    type: "",
    environment: "",
    tags: [],
    expectedFixDate: "",
    reportedById: user?.id,
    reportedByName: user?.name,
    assignedToJson: JSON.stringify([]),
    participants: [],
    reproducibleSteps: "",
    taskId: "",
    projectId: "",
    files: [],
  });
  const [participantEmail, setParticipantEmail] = useState("");
  const [showNotifyModal, setShowNotifyModal] = useState(false);
  const [pendingParticipant, setPendingParticipant] = useState(null);
  const fileInputRef = useRef(null);
  const [severities, setSeverities] = useState([]);
  const [environments, setEnvironments] = useState([]);
  const [type, setType] = useState([]);

  // Allowed mime types & max size (bytes)
  const ALLOWED_TYPES = [
    "image/png",
    "image/jpeg",
    "application/pdf",
    "application/msword", // .doc
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // .docx
    "text/plain", // .txt
    "text/csv", // .csv
    "application/vnd.ms-excel", // .xls
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // .xlsx
  ];
  const MAX_SIZE = 10 * 1024 * 1024; // 10 MB

  // Clipboard-paste listener (mount once)
  useEffect(() => {
    function handlePaste(e) {
      const files = [];
      const items = [...e.clipboardData.items];
      
      for (const item of items) {
        if (item.kind === 'file') {
          const file = item.getAsFile();
          if (file && ALLOWED_TYPES.includes(file.type)) {
            if (file.size > MAX_SIZE) {
              toast.error(`${file.name} exceeds 10 MB limit`);
              continue;
            }
            files.push(file);
          }
        }
      }

      if (files.length > 0) {
        setFormData(prev => ({
          ...prev,
          files: [...prev.files, ...files]
        }));
        toast.success(`Added ${files.length} file(s) from clipboard`);
      }
    }

    window.addEventListener("paste", handlePaste);
    return () => window.removeEventListener("paste", handlePaste);
  }, []);

  useEffect(() => {
    async function fetchInitialData() {
      const companyId =
        user?.accountType === "COMPANY" ? user.id : user?.companyId;

      try {
        // Fetch statuses
        const statusResponse = await axios.get(
          `${API_URL}/api/issueStatus/company/${companyId}`,
          {
            headers: {
              authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );

        // Fetch types
        const typeResponse = await axios.get(
          `${API_URL}/api/issueType/company/${companyId}`,
          {
            headers: {
              authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );

        // Fetch severities
        const severityResponse = await axios.get(
          `${API_URL}/api/severityTemplate/company/${companyId}`,
          {
            headers: {
              authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );

        // Fetch environments
        const environmentResponse = await axios.get(
          `${API_URL}/api/environment/company/${companyId}`,
          {
            headers: {
              authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );

        setStatuses(statusResponse.data);
        setType(typeResponse.data);
        setSeverities(severityResponse.data);
        setEnvironments(environmentResponse.data);
      } catch (error) {
        console.error("Error fetching initial data:", error);
      }
    }
    fetchInitialData();
  }, [user]);

  // Fetch Users
  useEffect(() => {
    async function fetchUsers() {
      if (!user?.id || !user?.accountType) return;
      const url =
        user?.accountType === "COMPANY"
          ? `${API_URL}/api/companyuser/getByUserId?userId=${user.id}&accountType=${user.accountType}`
          : `${API_URL}/api/companyuser/getSameAndSubordinateUsers?userId=${user.id}&accountType=${user.accountType}`;

      try {
        const response = await fetch(url, {
          method: "GET",
          headers: {
            authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        });

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const data = await response.json();
        setUsers(data);
      } catch (error) {
        console.error("Error fetching users:", error);
      }
    }
    fetchUsers();
  }, [user]);

  useEffect(() => {
    if (editData) {
      setFormData({
        companyId: editData.companyId,
        title: editData.title || "",
        description: editData.description || "",
        statusName: editData.statusName || "",
        statusColor: editData.statusColor || "",
        priority: editData.priority || "Low",
        severity: editData.severity || "",
        type: editData.type || "",
        environment: editData.environment || "",
        tags: editData.tags || [],
        expectedFixDate: editData.expectedFixDate || "",
        reportedById: editData.reportedById || user?.id,
        reportedByName: editData.reportedByName || user?.name,
        assignedToJson: editData.assignedTo 
          ? JSON.stringify(editData.assignedTo)
          : JSON.stringify([]),
        participants: editData.participants || [],
        reproducibleSteps: editData.reproducibleSteps || "",
        taskId: editData.taskId || "",
        projectId: editData.projectId || "",
        attachments: editData.attachments || [], 
        files: [], 
      });
      
      const participantEmails = editData.participants?.map(p => 
        Array.isArray(p) ? p[1] || p[0] : p
      ) || [];
      setParticipantEmail(participantEmails.join(', '));
    }
  }, [editData, user?.id, user?.name]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleAssignedUsersChange = (selectedOptions) => {
    const assignedUsers = selectedOptions.map((option) => ({
      id: option.value,
      name: option.label,
    }));

    setFormData({
      ...formData,
      assignedToJson: JSON.stringify(assignedUsers),
    });
  };

  const handleTagsChange = (e) => {
    const value = e.target.value;
    if (e.key === "Enter" || e.key === ",") {
      e.preventDefault();
      if (value.trim()) {
        setFormData((prev) => ({
          ...prev,
          tags: [...prev.tags, value.trim()],
        }));
        e.target.value = "";
      }
    }
  };

  const removeTag = (indexToRemove) => {
    setFormData((prev) => ({
      ...prev,
      tags: prev.tags.filter((_, index) => index !== indexToRemove),
    }));
  };

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    const validFiles = [];
    
    for (const file of files) {
      if (!ALLOWED_TYPES.includes(file.type)) {
        toast.error(`Unsupported file type: ${file.name}`);
        continue;
      }
      if (file.size > MAX_SIZE) {
        toast.error(`${file.name} exceeds 10 MB limit`);
        continue;
      }
      validFiles.push(file);
    }

    if (validFiles.length > 0) {
      setFormData(prev => ({
        ...prev,
        files: [...prev.files, ...validFiles]
      }));
    }
  };

  const removeFile = (indexToRemove) => {
    setFormData(prev => ({
      ...prev,
      files: prev.files.filter((_, index) => index !== indexToRemove)
    }));
  };

  const removeAttachment = (indexToRemove) => {
    setFormData(prev => ({
      ...prev,
      attachments: prev.attachments.filter((_, index) => index !== indexToRemove)
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      const formDataToSend = new FormData();
      
      // Append all form data to FormData object
      Object.keys(formData).forEach((key) => {
        if (formData[key] !== null && formData[key] !== undefined) {
          if (key === "files" && formData.files.length > 0) {
            formData.files.forEach(file => {
              formDataToSend.append("files", file);
            });
          } else if (key === "tags" && formData.tags.length > 0) {
            formData.tags.forEach(tag => {
              formDataToSend.append("tags", tag);
            });
          } else if (key === "participants" && formData.participants.length > 0) {
            formData.participants.forEach(participant => {
              formDataToSend.append("participants", participant);
            });
          } else {
            formDataToSend.append(key, formData[key]);
          }
        }
      });

      let response;
      if (editData) {
        response = await axios.put(
          `${API_URL}/api/issues/${editData.issueId}/updatedBy/${user.name}`,
          formDataToSend,
          {
            headers: {
              authorization: `Bearer ${localStorage.getItem("token")}`,
              "Content-Type": "multipart/form-data",
            },
          }
        );
      } else {
        response = await axios.post(
          `${API_URL}/api/issues`,
          formDataToSend,
          {
            headers: {
              authorization: `Bearer ${localStorage.getItem("token")}`,
              "Content-Type": "multipart/form-data",
            },
          }
        );
      }

      if (response.data?.status === "Successful") {
        toast.success(response.data.message);
        
        // Reset form
        setFormData({
          companyId: user.accountType === "COMPANY" ? user.id : user.companyId,
          title: "",
          description: "",
          statusName: "",
          statusColor: "",
          priority: "Low",
          severity: "",
          type: "",
          environment: "",
          tags: [],
          expectedFixDate: "",
          reportedById: user?.id,
          reportedByName: user?.name,
          assignedToJson: JSON.stringify([]),
          participants: [],
          reproducibleSteps: "",
          taskId: "",
          projectId: "",
          files: [],
          attachments: [],
        });

        // Close the form
        if (typeof showIssueForm === 'function') {
          showIssueForm(false);
        }
        if (typeof setOpenForm === 'function') {
          setOpenForm(null);
        }

        // Trigger update callbacks
        if (editData) {
          if (typeof onIssueUpdated === 'function') {
            onIssueUpdated(response.data);
          }
        } else {
          window.dispatchEvent(new Event("issueCreated"));
          if (typeof onIssueCreated === 'function') {
            onIssueCreated(response.data);
          }
        }
        
        showIssueForm?.(false);
        setOpenForm?.(null);
      } else {
        toast.error(response.data?.message);
      }
    } catch (error) {
      console.error("Issue operation error:", error);
      toast.error(error.response?.data?.message || error.message);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleAddParticipant = () => {
    setEmailError("");

    if (!participantEmail) {
      setEmailError("Please enter an email address");
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(participantEmail)) {
      setEmailError("Please enter a valid email address");
      return;
    }

    const isDuplicate = formData.participants.some((participant) => {
      const email = Array.isArray(participant)
        ? participant[1] || participant[0]
        : participant;
      return email.toLowerCase() === participantEmail.toLowerCase();
    });

    if (isDuplicate) {
      setEmailError("This email is already added");
      return;
    }

    const matchedUser = users.find(
      (u) => u.email.toLowerCase() === participantEmail.toLowerCase()
    );
    if (matchedUser) {
      setPendingParticipant({ id: matchedUser.id, email: participantEmail });
      setShowNotifyModal(true);
    } else {
      setFormData((prev) => ({
        ...prev,
        participants: [...prev.participants, [participantEmail]],
      }));
      setParticipantEmail("");
    }
  };

  const confirmParticipant = (type) => {
    let entry =
      type === "both"
        ? [pendingParticipant.id, pendingParticipant.email]
        : [pendingParticipant.email];

    setFormData((prev) => ({
      ...prev,
      participants: [...prev.participants, entry],
    }));

    setShowNotifyModal(false);
    setPendingParticipant(null);
    setParticipantEmail("");
  };

  return (
    <>
      <style>{`@import url('https://fonts.googleapis.com/css2?family=Sora:wght@600;700&family=Inter:wght@400;500;600&display=swap'); .cfg-heading{font-family:'Sora',sans-serif;color:#1F2937;} .cfg-font{font-family:'Inter',sans-serif;}`}</style>
      <form
        onSubmit={handleSubmit}
        className="grid gap-5 p-4 w-full max-w-4xl mx-auto bg-white cfg-font rounded-lg border border-[#E5E7EB] dark:border-gray-700 dark:bg-gray-800"
      >
        {/* Title Field */}
        <div className="w-full">
          <label className="block text-sm font-semibold text-[#374151] mb-1.5 dark:text-gray-200">
            Title*
          </label>
          <input
            type="text"
            name="title"
            value={formData.title}
            onChange={handleChange}
            required
            className="w-full p-2.5 border border-[#E5E7EB] rounded-md focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7] dark:bg-gray-700 dark:border-gray-600 dark:text-white"
            placeholder="Issue title"
          />
        </div>

        {/* Priority, Type, Status, Severity Row */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 dark:text-white">
          {/* Priority */}
          <div className="w-full">
            <label className="block text-sm font-semibold text-[#374151] mb-1.5 dark:text-gray-200">
              Priority
            </label>
            <select
              name="priority"
              value={formData.priority}
              onChange={handleChange}
              className="w-full p-2.5 border border-[#E5E7EB] rounded-md focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7] dark:bg-gray-700 dark:border-gray-600 dark:text-white"
            >
              <option value="Low">Low</option>
              <option value="Medium">Medium</option>
              <option value="High">High</option>
            </select>
          </div>

          {/* Type */}
          <div className="w-full">
            <label className="block text-sm font-semibold text-[#374151] mb-1.5 dark:text-gray-200">
              Type
            </label>
            <select
              name="type"
              value={formData.type}
              onChange={handleChange}
              className="w-full p-2.5 border border-[#E5E7EB] rounded-md focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7] dark:bg-gray-700 dark:border-gray-600 dark:text-white"
            >
              <option value="">Select Type</option>
              {type.map((t) => (
                <option key={t.id} value={t.name}>
                  {t.name}
                </option>
              ))}
            </select>
          </div>

          {/* Status */}
          <div className="w-full">
            <label className="block text-sm font-semibold text-[#374151] mb-1.5 dark:text-gray-200">
              Status
            </label>
            <select
              name="statusName"
              value={formData.statusName}
              onChange={(e) => {
                const selectedStatus = statuses.find(
                  (status) => status.name === e.target.value
                );
                setFormData({
                  ...formData,
                  statusName: e.target.value,
                  statusColor: selectedStatus ? selectedStatus.color : "",
                });
              }}
              className="w-full p-2.5 border border-[#E5E7EB] rounded-md focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7] dark:bg-gray-700 dark:border-gray-600 dark:text-white"
            >
              <option value="">Select Status</option>
              {statuses
              .filter(status => status.active === true)
              .map((status) => (
                <option key={status.id} value={status.name}>
                  {status.name}
                </option>
              ))}
            </select>
          </div>

          {/* Severity */}
          <div className="w-full">
            <label className="block text-sm font-semibold text-[#374151] mb-1.5 dark:text-gray-200">
              Severity
            </label>
            <select
              name="severity"
              value={formData.severity}
              onChange={handleChange}
              className="w-full p-2.5 border border-[#E5E7EB] rounded-md focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7] dark:bg-gray-700 dark:border-gray-600 dark:text-white"
            >
              <option value="">Select Severity</option>
              {severities.map((severity) => (
                <option key={severity.id} value={severity.name}>
                  {severity.name}
                </option>
              ))}
            </select>
          </div>
        </div>

        {/* Environment and Expected Fix Date */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {/* Environment */}
          <div className="w-full">
            <label className="block text-sm font-semibold text-[#374151] mb-1.5 dark:text-gray-200">
              Environment
            </label>
            <select
              name="environment"
              value={formData.environment}
              onChange={handleChange}
              className="w-full p-2.5 border border-[#E5E7EB] rounded-md focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7] dark:bg-gray-700 dark:border-gray-600 dark:text-white"
            >
              <option value="">Select Environment</option>
              {environments.map((env) => (
                <option key={env.id} value={env.name}>
                  {env.name}
                </option>
              ))}
            </select>
          </div>

          {/* Expected Fix Date */}
          <div className="w-full">
            <label className="block text-sm font-semibold text-[#374151] mb-1.5 dark:text-gray-200">
              Expected Fix Date
            </label>
            <input
              type="date"
              name="expectedFixDate"
              value={formData.expectedFixDate}
              onChange={handleChange}
              min={new Date().toISOString().split("T")[0]}
              className="w-full p-2.5 border border-[#E5E7EB] rounded-md focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7] dark:bg-gray-700 dark:border-gray-600 dark:text-white"
            />
          </div>
        </div>

        {/* Assign To */}
        <div className="w-full">
          <label className="block text-sm font-semibold text-[#374151] mb-1.5 dark:text-gray-200">
            Assign To
          </label>
          <Select
            isMulti
            name="assignedToJson"
            options={users.map((user) => ({
              value: user.id,
              label: `${user.fname} ${user.lname}`,
            }))}
            value={
              formData.assignedToJson
                ? JSON.parse(formData.assignedToJson).map(user => ({
                    value: user.id,
                    label: user.name
                  }))
                : []
            }
            onChange={handleAssignedUsersChange}
            className="basic-multi-select"
            classNamePrefix="select"
            styles={{
              control: (base, state) => ({
                ...base,
                minHeight: "42px",
                backgroundColor: document.documentElement.classList.contains('dark') 
                  ? '#374151' 
                  : '#ffffff',
                borderColor: document.documentElement.classList.contains('dark') 
                  ? '#4B5563' 
                  : '#E5E7EB',
                '&:hover': {
                  borderColor: document.documentElement.classList.contains('dark') 
                    ? '#6B7280' 
                    : '#8B5CF6',
                },
                boxShadow: state.isFocused 
                  ? (document.documentElement.classList.contains('dark')
                      ? '0 0 0 2px #8B5CF6' 
                      : '0 0 0 2px #E9D5FF') 
                  : base.boxShadow,
              }),
              menu: (base) => ({
                ...base,
                backgroundColor: document.documentElement.classList.contains('dark') 
                  ? '#1F2937' 
                  : base.backgroundColor,
              }),
              option: (base, state) => ({
                ...base,
                backgroundColor: state.isFocused 
                  ? (document.documentElement.classList.contains('dark')
                      ? '#4B5563' 
                      : '#F3F4F6') 
                  : state.isSelected
                  ? (document.documentElement.classList.contains('dark')
                      ? '#673AB7' 
                      : '#673AB7') 
                  : base.backgroundColor,
                color: state.isSelected 
                  ? '#ffffff'
                  : document.documentElement.classList.contains('dark')
                  ? '#F9FAFB' 
                  : '#374151',
              }),
              multiValue: (base) => ({
                ...base,
                backgroundColor: document.documentElement.classList.contains('dark')
                  ? '#4B5563' 
                  : '#F3E8FF', 
              }),
              multiValueLabel: (base) => ({
                ...base,
                color: document.documentElement.classList.contains('dark')
                  ? '#F9FAFB' 
                  : '#673AB7',
                fontWeight: '500',
              }),
              multiValueRemove: (base) => ({
                ...base,
                color: document.documentElement.classList.contains('dark')
                  ? '#F9FAFB' 
                  : '#673AB7',
                ':hover': {
                  backgroundColor: document.documentElement.classList.contains('dark')
                    ? '#6B7280' 
                    : '#E9D5FF', 
                },
              }),
              input: (base) => ({
                ...base,
                color: document.documentElement.classList.contains('dark')
                  ? '#F9FAFB' 
                  : '#374151',
              }),
              placeholder: (base) => ({
                ...base,
                color: document.documentElement.classList.contains('dark')
                  ? '#9CA3AF' 
                  : '#9CA3AF',
              }),
            }}
          />
        </div>

        {/* Tags */}
        <div className="w-full">
          <label className="block text-sm font-semibold text-[#374151] mb-1.5 dark:text-gray-200">
            Tags
          </label>
          <div className="flex flex-wrap gap-2 mb-2">
            {formData.tags.map((tag, index) => (
              <div
                key={index}
                className="flex items-center bg-[#F3E8FF] text-[#673AB7] font-medium px-3 py-1 rounded-full text-sm dark:bg-purple-900 dark:text-purple-200 border border-[#E9D5FF] dark:border-purple-700"
              >
                {tag}
                <button
                  type="button"
                  onClick={() => removeTag(index)}
                  className="ml-2 text-[#673AB7] hover:text-[#5E35A6] dark:text-purple-200 dark:hover:text-purple-400 font-bold"
                >
                  ×
                </button>
              </div>
            ))}
          </div>
          <input
            type="text"
            onKeyDown={handleTagsChange}
            onBlur={(e) => {
              if (e.target.value.trim()) {
                setFormData((prev) => ({
                  ...prev,
                  tags: [...prev.tags, e.target.value.trim()],
                }));
                e.target.value = "";
              }
            }}
            className="w-full p-2.5 border border-[#E5E7EB] rounded-md focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7] dark:bg-gray-700 dark:border-gray-600 dark:text-white"
            placeholder="Type tag and press Enter or comma"
          />
        </div>

        {/* Participant Email Input */}
        <div className="w-full">
          <label className="block text-sm font-semibold text-[#374151] mb-1.5 dark:text-gray-200">
            Participant Email
          </label>
          <div className="flex gap-2">
            <input
              type="email"
              value={participantEmail}
              onChange={(e) => {
                setParticipantEmail(e.target.value);
                setEmailError("");
              }}
              className={`w-full p-2.5 border rounded-md focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7] dark:bg-gray-700 dark:text-white ${
                emailError ? "border-[#EF4444]" : "border-[#E5E7EB] dark:border-gray-600"
              }`}
              placeholder="Add participant email"
            />
            <button
              type="button"
              onClick={handleAddParticipant}
              className="px-4 py-2.5 bg-[#673AB7] text-white font-semibold rounded-md hover:bg-[#5E35A6] transition"
            >
              Add
            </button>
          </div>
          {emailError && (
            <p className="mt-1 text-sm text-[#EF4444] dark:text-red-400">
              {emailError}
            </p>
          )}
        </div>

        {/* List of Added Participants */}
        {formData.participants.length > 0 && (
          <div className="mt-1 space-y-2">
            {formData.participants.map((participant, index) => {
              const email = Array.isArray(participant)
                ? participant[1] || participant[0]
                : participant;
              return (
                <div
                  key={index}
                  className="flex items-center justify-between bg-[#F3F4F6] border border-[#E5E7EB] dark:border-gray-600 dark:bg-gray-700 px-3 py-2 rounded-md"
                >
                  <span className="text-sm font-medium text-[#374151] dark:text-gray-200">
                    {email}
                  </span>
                  <button
                    type="button"
                    onClick={() => {
                      setFormData((prev) => ({
                        ...prev,
                        participants: prev.participants.filter(
                          (_, i) => i !== index
                        ),
                      }));
                    }}
                    className="text-[#EF4444] hover:text-[#B91C1C] text-sm"
                    title="Remove"
                  >
                    ❌
                  </button>
                </div>
              );
            })}
          </div>
        )}

        {/* Description */}
        <div className="w-full">
          <label className="block text-sm font-semibold text-[#374151] mb-1.5 dark:text-gray-200">
            Description*
          </label>
          <textarea
            name="description"
            value={formData.description}
            onChange={handleChange}
            required
            className="w-full p-2.5 border border-[#E5E7EB] rounded-md focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7] min-h-[120px] dark:bg-gray-700 dark:border-gray-600 dark:text-white"
            placeholder="Detailed description of the issue"
          ></textarea>
        </div>

        {/* Reproducible Steps */}
        <div className="w-full">
          <label className="block text-sm font-semibold text-[#374151] mb-1.5 dark:text-gray-200">
            Reproducible Steps
          </label>
          <textarea
            name="reproducibleSteps"
            value={formData.reproducibleSteps}
            onChange={handleChange}
            className="w-full p-2.5 border border-[#E5E7EB] rounded-md focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7] min-h-[120px] dark:bg-gray-700 dark:border-gray-600 dark:text-white"
            placeholder="Steps to reproduce the issue"
          ></textarea>
        </div>

        {/* File Upload */}
        <div className="w-full border border-[#E5E7EB] p-4 rounded-md dark:border-gray-700">
          <label className="block text-sm font-semibold text-[#374151] mb-2 dark:text-gray-200">
            Upload Files
          </label>
          <input
            ref={fileInputRef}
            type="file"
            name="files"
            multiple
            accept=".png,.jpg,.jpeg,.pdf,.doc,.docx,.txt,.csv,.xls,.xlsx"
            onChange={handleFileChange}
            className="w-full text-sm text-[#6B7280] dark:text-gray-300 file:mr-4 file:py-2 file:px-4 file:rounded-md file:border-0 file:text-sm file:font-semibold file:bg-[#F3E8FF] file:text-[#673AB7] hover:file:bg-[#E9D5FF] transition dark:file:bg-purple-900/50 dark:file:text-purple-300"
          />
          <p className="mt-2 text-xs text-[#6B7280] dark:text-gray-400">
            PNG, JPG, PDF, DOC, DOCX, TXT, CSV, XLS, XLSX — max 10 MB. Multiple files allowed.
            You can also paste files directly.
          </p>
          
          {/* Display existing attachments */}
          {formData.attachments && formData.attachments.length > 0 && (
            <div className="mt-4 space-y-2">
              <p className="text-sm font-semibold text-[#374151] dark:text-gray-200 border-b border-[#E5E7EB] dark:border-gray-600 pb-1">Existing Attachments:</p>
              {formData.attachments.map((attachment, index) => (
                <div key={`attachment-${index}`} className="flex items-center justify-between bg-[#F3F4F6] dark:bg-gray-700 border border-[#E5E7EB] dark:border-gray-600 px-3 py-2 rounded-md">
                  <span className="text-sm font-medium text-[#374151] dark:text-gray-200 truncate max-w-xs">
                    {attachment.split('_').slice(1).join('_')}
                  </span>
                  <button
                    type="button"
                    onClick={() => removeAttachment(index)}
                    className="text-[#EF4444] hover:text-[#B91C1C] text-sm"
                    title="Remove"
                  >
                    ❌
                  </button>
                </div>
              ))}
            </div>
          )}
          
          {/* Display new files to be uploaded */}
          {formData.files.length > 0 && (
            <div className="mt-4 space-y-2">
              <p className="text-sm font-semibold text-[#374151] dark:text-gray-200 border-b border-[#E5E7EB] dark:border-gray-600 pb-1">New Files:</p>
              {formData.files.map((file, index) => (
                <div key={`file-${index}`} className="flex items-center justify-between bg-[#F3F4F6] dark:bg-gray-700 border border-[#E5E7EB] dark:border-gray-600 px-3 py-2 rounded-md">
                  <span className="text-sm font-medium text-[#374151] dark:text-gray-200 truncate max-w-xs">
                    {file.name} ({Math.round(file.size / 1024)} KB)
                  </span>
                  <button
                    type="button"
                    onClick={() => removeFile(index)}
                    className="text-[#EF4444] hover:text-[#B91C1C] text-sm"
                    title="Remove"
                  >
                    ❌
                  </button>
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Submit Button */}
        <button
          type="submit"
          disabled={isSubmitting}
          className={`w-full p-3 mt-2 text-white rounded-md font-bold text-base shadow-md transition-colors duration-200 ${
            isSubmitting
              ? "bg-[#9CA3AF] cursor-not-allowed shadow-none"
              : editData 
                ? "bg-[#10B981] hover:bg-[#059669]" 
                : "bg-[#673AB7] hover:bg-[#5E35A6]"
          }`}
        >
          {isSubmitting 
            ? editData 
              ? "Updating..." 
              : "Creating..."
            : editData 
              ? "Update Issue" 
              : "Create Issue"}
        </button>

        {showNotifyModal && (
          <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50">
            <div className="bg-white p-6 rounded-xl shadow-2xl w-full max-w-md text-center dark:bg-gray-800 dark:text-white border border-[#E5E7EB] dark:border-gray-700">
              <div className="flex justify-end">
                <button
                  type="button"
                  onClick={() => {
                    setShowNotifyModal(false);
                    setOpenForm?.(null);
                  }}
                  className="text-[#6B7280] hover:text-[#EF4444] dark:hover:text-red-400 text-xl font-bold transition"
                  aria-label="Close"
                >
                  &times;
                </button>
              </div>
              <h2 className="text-xl font-bold cfg-heading text-[#1F2937] dark:text-white mb-4">
                Notification Preference
              </h2>
              <p className="mb-6 text-[#374151] dark:text-gray-300">
                How would you like to notify{" "}
                <span className="font-bold text-[#673AB7] dark:text-[#E9D5FF]">{pendingParticipant.email}</span>?
              </p>
              <div className="flex justify-around gap-4">
                <button
                  onClick={() => confirmParticipant("both")}
                  className="px-4 py-2 bg-[#10B981] text-white font-semibold rounded-md hover:bg-[#059669] shadow-sm transition w-full"
                >
                  Notification + Email
                </button>
                <button
                  onClick={() => confirmParticipant("email")}
                  className="px-4 py-2 bg-[#F59E0B] text-white font-semibold rounded-md hover:bg-[#D97706] shadow-sm transition w-full"
                >
                  Email Only
                </button>
              </div>
            </div>
          </div>
        )}
      </form>
    </>
  );
}